export default function Tabs(theme) {
  return {
    MuiTabs: {
      defaultProps: {
        elevation: 0,
      },

      styleOverrides: {
        root: {
          padding: "2px",
          minHeight: "42px",
          borderRadius: "22px",
          backgroundColor: "#FFFFFF",
          fontSize: "12px",
        },
        flexContainer: {
          display: 'flex',
          flexDirection: "row",
          justifyContent: "space-between"
        },
        indicator: {
          backgroundColor: "#ffffff00",
        },
      },
    },
    MuiTab: {
      defaultProps: {
        elevation: 0,
      },

      styleOverrides: {
        root: {
          padding: "13px",
          minHeight: "36px",
          minWidth: "62px",
          fontSize: "12px",
          "&:hover": {
            backgroundColor: "#FFFFFF",
            borderRadius: "22px",
          },
          "&.Mui-selected": {
            backgroundColor: "#eff4ff",
            borderRadius: "22px",
            fontSize: "12px",
          },
          
        },
      },
    },
  };
}
